/* Progressive enhancement only; search, localisation and filters remain GET/native forms. */
(() => {
  'use strict';
  const boundHeaders = new WeakSet();
  const boundForms = new WeakSet();

  function enhanceHeader(header) {
    if (boundHeaders.has(header)) return;
    boundHeaders.add(header);
    const opener = header.querySelector('[data-yf-menu-open]');
    const dialog = header.querySelector('[data-yf-menu-dialog]');
    const panels = dialog ? [...dialog.querySelectorAll('[data-yf-nav-panel]')] : [];
    let source = null;
    let pageOverflow = '';
    let lastBranch = null;
    const showPanel = name => {
      const next = panels.find(panel => panel.dataset.yfNavPanel === name);
      if (!next) return;
      panels.forEach(panel => { panel.hidden = panel !== next; });
      dialog.querySelectorAll('[data-yf-nav-target]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.yfNavTarget === name)));
      if (name === 'root') {
        if (lastBranch && lastBranch.isConnected) lastBranch.focus();
      } else {
        next.querySelector('[data-yf-panel-title]')?.focus();
      }
      if (dialog) dialog.scrollTop = 0;
    };
    const close = () => { if (dialog?.open) dialog.close(); };
    if (opener && dialog && typeof dialog.showModal === 'function') {
      opener.addEventListener('click', () => {
        if (dialog.open) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.yfNavPanel !== 'root'; });
        dialog.querySelectorAll('[data-yf-nav-target]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        source = document.activeElement;
        pageOverflow = document.documentElement.style.overflow;
        dialog.showModal(); // Native modal isolates the background and contains keyboard focus.
        document.documentElement.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-yf-menu-close]')?.focus();
      });
      dialog.addEventListener('click', event => {
        const closeButton = event.target.closest('[data-yf-menu-close]');
        const branch = event.target.closest('[data-yf-nav-target]');
        if (closeButton) close();
        else if (branch) { lastBranch = branch; showPanel(branch.dataset.yfNavTarget); }
        else if (event.target.closest('[data-yf-nav-back]')) showPanel('root');
        else if (event.target.closest('a[href]')) close();
        else if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
        }
      });
      dialog.addEventListener('close', () => {
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = pageOverflow;
        if (source && source.isConnected && typeof source.focus === 'function') source.focus();
      });
      // Escape uses the native dialog cancel/close sequence, including focus restoration.
      const desktop = window.matchMedia('(min-width:1000px)');
      desktop.addEventListener('change', event => { if (event.matches) close(); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(header)) close(); });
    } else if (opener) {
      opener.hidden = true; // The visible search and catalogue links remain usable in older browsers.
    }
    const megas = [...header.querySelectorAll('[data-yf-mega]')];
    const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
    megas.forEach(details => {
      let leaveTimer;
      details.addEventListener('toggle', () => {
        if (details.open) megas.forEach(other => { if (other !== details) other.open = false; });
      });
      details.addEventListener('pointerenter', () => {
        window.clearTimeout(leaveTimer);
        if (finePointer.matches) details.open = true;
      });
      details.addEventListener('pointerleave', () => {
        if (!finePointer.matches) return;
        leaveTimer = window.setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 180);
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          details.querySelector('summary')?.focus();
          event.preventDefault();
          event.stopPropagation();
        }
      });
      details.addEventListener('focusout', event => {
        if (!details.contains(event.relatedTarget)) details.open = false;
      });
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) megas.forEach(details => { details.open = false; });
    });
  }

  function enhance(scope = document) {
    scope.querySelectorAll('[data-yf-navigation]').forEach(enhanceHeader);
    scope.querySelectorAll('[data-yf-language-select]').forEach(select => {
      if (boundForms.has(select)) return;
      boundForms.add(select);
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
    scope.querySelectorAll('[data-yf-catalog-form]').forEach(form => {
      if (boundForms.has(form)) return;
      boundForms.add(form);
      form.querySelector('[data-yf-sort]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('submit', () => {
        // Empty range controls must not become artificial zero-price filters.
        form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value.trim() === '') input.disabled = true; });
      });
      const facets = form.querySelector('.yf-facets-disclosure');
      if (facets) {
        document.addEventListener('click', event => { if (!facets.contains(event.target)) facets.open = false; });
        facets.addEventListener('keydown', event => {
          if (event.key === 'Escape' && facets.open) { facets.open = false; facets.querySelector('summary')?.focus(); event.preventDefault(); }
        });
      }
    });
    // A manually entered /search?q= URL also stays product-only, as every search form does.
    if (scope.querySelector('[data-yf-product-search]')) {
      const url = new URL(window.location.href);
      if (url.searchParams.has('q') && url.searchParams.get('type') !== 'product') {
        url.searchParams.set('type', 'product');
        window.location.replace(url.href);
        return;
      }
    }
    document.documentElement.classList.add('yf-navigation-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
